<template>
  <div style="background-color:#f4f4f4; min-width:1220px;">
    <navCom :navActive="navActive"></navCom>
    <!--swiper start-->
    <div class="syy-swiper">
      <swiper :options="swiperOption" v-if="banner.length>=1">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in banner" :key="index">
          <a v-show="item.banner_link!=''" :href="item.banner_link" target="_blank" style="display: block;height: 576px;">
            <img :src="item.banner_url" alt="">
          </a>
          <a v-show="item.banner_link==''" href="javascript:;" style="display: block;height: 576px;">
            <img :src="item.banner_url" alt="">
          </a>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination"  slot="pagination"></div>
      </swiper>
      <div class="syy-listing w">
        <div class="syy-listing-center">
          <div class="banner-nav">
            <p class="banner-nav-title">
              <span>课程分类</span>
            </p>
          </div>
          <ul>
            <li v-for="(item,index) in course_type" :key="index" @click="courseFun(item.id)"><a href="javascript:void(0)"><span>{{item.title}}</span><span>></span></a></li>
          </ul>
        </div>
      </div>
    </div>
    <!--swiper end-->
    <!--文本 start-->
    <div class="index-count">
        <div class="index-count-left">
          <h1>{{account.encouraging_discourse}}</h1>
          <p>{{account.introduce}}</p>
          <router-link to="/aboutuser/brief">
          <span>了解更多</span>
          </router-link>
        </div>
        <div class="index-count-right">
          <img :src="account.logo" alt="">
        </div>
      </div>
    <!--文本end-->
    <!-- 线上课 start-->
    <div class="index-main">
      <div class="index-main-left index-main-bg1">
        <h3>线上课程</h3>
        <div class="line"><img src="../../static/images/zmr-images/index-main-line.png" width="100%" alt=""></div>
        <p>名师精心 梦想成真</p>
      </div>
      <div class="index-main-right">
        <div class="index-main-right-top top-border-red">
          <p class="title-red">线上精品课</p>
          <div @click="toOnline">
            <span>查看更多></span>
          </div>
        </div>
        <ul class="course-ul">
          <li @click="toDetail(item.id)" v-for="(item,index) in online_course_list" v-if="index < 3">
            <div class="course-img"><img :src="item.course_pic" width="100%"></div>
            <div class="course-main">
              <h3 class="title">{{item.course_name}}</h3>
              <p class="course-label">
                <span  v-for="(iteml,i) of item.course_label" :key="i" v-show="iteml.a!=null">{{iteml.a}}</span>
              </p>
              <div class="course-content">
                <p class="course-content-txt"><i class="course-content-icon"><img src="../../static/images/zmr-images/video.png" width="100%"></i>共{{item.video_num}}个视频</p>
                <p class="course-content-txt"><i class="course-content-icon"><img src="../../static/images/zmr-images/note.png" width="100%"></i>共约{{item.total_time}}小时</p>
              </div>
              <div class="course-price">
                <span class="present-price">￥{{item.preferential_price}}</span>
                <span class="original-price">原价：{{item.original_price}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 线上课 end-->
    <!-- 直播课 start-->
    <div class="index-main">
      <div class="index-main-left index-main-bg2" style="height: 433px;">
        <h3>直播课程</h3>
        <div class="line"><img src="../../static/images/zmr-images/index-main-line.png" width="100%" alt=""></div>
        <p>创制人才 铸就新星</p>
      </div>
      <div class="index-main-right" style="height: 433px;">
        <div class="index-main-right-top top-border">
          <p class="title-litter-blue">直播精品课</p>
          <router-link to="/live-class">
            <span>查看更多></span>
          </router-link>
        </div>
        <ul class="course-ul">
          <li  style="height: 350px;" @click="liveDetail(item.id)" v-for="(item,index) in live_course_list" :key="index">
            <div class="course-img"><img :src="item.course_pic" width="100%"></div>
            <div class="course-main">
              <h3 class="title">{{item.course_name}}</h3>
              <div class="course-content">
                <p class="course-content-txt"><i class="course-content-icon"><img src="../../static/images/zmr-images/calendar.png" width="100%"></i>{{item.live_start_time}}</p>
                <p class="course-content-txt"><i class="course-content-icon"><img src="../../static/images/zmr-images/clock.png" width="100%"></i>{{item.live_end_time}}</p>
              </div>
              <div class="course-price">
                <span class="present-price">￥{{item.preferential_price}}</span>
                <span class="original-price">原价：{{item.original_price}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 直播课 1end-->
    <footer-com></footer-com>
  </div>
</template>

<script>
import navCom from '../components/welcome-nav'
import footerCom from '../components/foot'
import tool from '../assets/js/tool.js'
export default {
  name: 'index',
  data(){
    return{
      navActive: 0, //当前导航
      swiperOption: {
        pagination:{
          el: '.swiper-pagination',
        },
        loop : true,
        autoplay:true
      },
      course_type:Array,//banner课程
      banner:Array,//轮播图图片
      account:Object,//文本
      online_course_list:Array,//线上课
      live_course_list:Array,//直播课
    }
  },
  methods:{
    /*跳转课程详情*/
    toDetail(id){
      this.$router.push({
        path: `/list-detail`,
        query: {course_id:id},
      })
    },
    /*跳转直播课程详情*/
    liveDetail(id){
      this.$router.push({
        path: `/live-class-detail`,
        query: {course_id:id},
      })
    },
    toOnline() {
      this.$router.push({
        path: `/online_class`,
        query: {parent_id: 1},
      })
    },
    getIndex(){
      let data = {};
      tool.postData('index/index', data,(res) => {//首页信息
        console.log(res.data.data)
        this.course_type = res.data.data.course_type;//banner课程
        this.banner=res.data.data.banner;//banner图片、连接
        this.account = res.data.data.account;//文本
        this.online_course_list=res.data.data.course_list.online_course_list;//线上课
        this.live_course_list=res.data.data.course_list.live_course_list;//直播课
      })
    },
    courseFun(id){
      this.$router.push({
        path: `/online_class`,
        query: {
          parent_id:id,
        },
      })
    }
  },
  mounted(){
    this.getIndex()
  },
  components: {
    navCom,
    footerCom
  }
}
</script>

<style scoped>
  .syy-swiper{
    position:relative;
    height: 576px;
  }
  .syy-swiper .swiper-slide {
    width: 100%;
    height: 576px;
  }
  .syy-swiper .swiper-slide img{
    width: 100%;
    height: 100%;
  }
  .syy-listing{
    height: 450px;
    position:absolute;
    top:0;
    left: 19%;
    z-index:11;
  }
  .syy-listing  .syy-listing-center{
    float: left;
    width: 230px;
    background: rgba(0,0,0,0.5);
  }
  .banner-nav{
    background-color: #1970ff;
  }
  .banner-nav-title{
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    padding:15px 20px;
    box-sizing: border-box;
    display:flex;
    justify-content: space-between;
  }
  .syy-listing  ul li a{
    font-size:16px;
    font-family:"Microsoft YaHei UI";
    color: #fff;
  }
  .syy-listing  ul{
    margin: 6px 17px 9px;
  }
  .syy-listing  ul li{
    height: 55px;
    line-height: 55px;
    border-bottom:1px solid #fff;
    cursor: pointer;
  }
  .syy-listing  ul li:last-child{
    border:none;
  }
  .syy-listing  ul li:hover a span{
    color: #1970ff;
  }
  .syy-listing  ul li:last-child{
    /*border:none;*/
  }
  .syy-listing  ul li span:last-child{
    float: right;
    color:#fff;
    font-family:cursive;
  }
  .syy-listing-r{
    width: 947px;
    float: right;
    height: 100%;
  }
  .syy-listing-r .swiper-button-prev{
    left: inherit;
  }
  .syy-listing-r  .swiper-button-prev,.syy-listing-r  .swiper-button-next{
    width: 43px;
    height: 43px;
    background: rgba(0, 0, 0, 0.3);
    color:#ffffff;
    border-radius:50%;
    line-height:43px;
    text-align:center;
    font-size:30px;
    font-family:cursive;
    outline:none;
  }
  /deep/ .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50% 50%;
    background:#ffffff;
    opacity:0.35;
  }   /*加/deep/深层穿透*/
  /deep/ .swiper-pagination-bullet-active {
    background: #ffffff;
    opacity:1;
  }
  .swiper-pagination-bullets {
    bottom: 10px;
    left: 45%;
    width:auto;
    background-color:rgba(146,146,146,.3);
    border-radius:20px 20px;
  }
  /deep/.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 10px;
    vertical-align: middle;
  }
  .banner-text{
    position: absolute;
    right: 10%;
    top: 30%;
    color: #fff;
    font-size: 60px;
    z-index: 11;
    line-height: 95px;
    text-align: right;
    cursor:default;
  }
  .index-count{
    width: 1220px;
    margin:130px auto 0;
    display: flex;
    justify-content: space-between;
  }
  .index-count-left{
    width:470px;
  }
  .index-count-left h1{
    margin-bottom: 50px;
    margin-top:10px;
    font-size:40px;
    color: #1a71ff;
    font-weight: normal;
  }
  .index-count-left p{
    color:#6a6a6a;
    font-size: 16px;
    text-align: justify;
    margin-bottom: 43px;
  }
  .index-count-left span{
    width: 150px;
    height: 41px;
    display: block;
    border-radius:20px 20px;
    border:1px solid #6a6a6a;
    line-height: 41px;
    text-align: center;
    color: #6a6a6a;
    font-size: 16px;
    cursor: pointer;
  }
  .index-count-left span:hover{
    border:none;
    background-color: #1a71ff;
    color: #fff;
  }
  .index-count-right img{
    width:633px;
    height: 372px;
  }
  .index-main{
    width: 1220px;
    margin: 70px auto 0;
    display: flex;
    justify-content: space-between;
  }
  .index-main-left{
    width: 235px;
    height:467px;
    padding-top: 66px;
    box-sizing: border-box;
    text-align: center;
  }
  .index-main-bg1{
    background: url("../../static/images/zmr-images/online-bg.png") no-repeat top center;
    background-size:100% 100%;
  }
  .index-main-bg2{
    background: url("../../static/images/zmr-images/live-bg.png") no-repeat top center;
    background-size:100% 100%;
  }
  .index-main-right{
    width: 934px;
  }
  .index-main-left .line{
    width: 184px;
    margin: 13px auto 15px;
  }
  .index-main-left h3{
    font-size: 26px;
    color: #fff;
    font-weight: bold;
  }
  .index-main-left p{
    font-size: 18px;
    color: #fff;
  }
  .index-main-right-top{
    width: 100%;
    height:40px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
  }
  .index-main-right-top p{
    font-size: 18px;
  }
  .index-main-right-top span{
    font-size: 16px;
    color: #676767;
    cursor: pointer;
  }
  .course-ul{
    display: flex;
    align-items: flex-start;
    flex-wrap:wrap;
  }
  .course-ul li{
    cursor: pointer;
    width: 270px;
    height: 387px;
    border: 1px solid #c9c9c9;
    display: inline-block;
    margin-bottom: 10px;
    background-color: #fff;
  }
  .course-ul li:nth-child(2){
    margin: 0 55px;
  }
  .course-img{
    height: 159px;
    position: relative;
    overflow: hidden;
  }
  .course-img img:after{
    /*content: url('../assets/img/index/course_bitmap.png');*/
    display: block;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
  .course-main{
    padding: 0 10px 0 15px;
    box-sizing: border-box;
    min-height: 210px;
    position: relative;
  }
  .course-main .title{
    color: #414141;
    font-size: 22px;
    line-height: 42px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .course-label{
    margin-bottom: 10px;
    min-height: 40px;
  }
  .course-label span{
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 14px;
    border-radius: 20px;
    margin: 5px 7px 0 0;
    display: inline-block;
    line-height: 23px;
  }
  .course-label span:nth-child(n){
    color: #e60012;
    border: 1px solid #e60012;
  }
  .course-label span:nth-child(2n){
    color: #2996e2;
    border: 1px solid #2996e2;
  }
  .course-label span:nth-child(3n){
    color: #ff8e00;
    border: 1px solid #ff8e00;
  }
  .course-content-txt{
    font-size: 14px;
    color: #888888;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .course-content-icon{
    width: 12px;
    display: inline-block;
    vertical-align: text-top;
    margin-right: 14px;
  }
  .course-price{
    margin-top:37px;
  }
  .present-price{
    font-size: 24px;
    color: #ce0000;
    line-height: 0;
    font-weight: bold;
  }
  .original-price{
    font-size: 12px;
    color: #999;
    vertical-align: bottom;
    text-decoration:line-through;
    line-height: 14px;
    margin-left: 7px;
  }
  .top-border-red{
    border-bottom: 2px solid #1a71ff;
  }
  .index-main-right-top .title-red{
    color: #1a71ff;
  }
  .top-border{
    border-bottom: 2px solid #48b5fa;
  }
  .index-main-right-top .title-litter-blue{
    color: #48b5fa;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue